/**
 * Подтверждение владения новым номером телефона
 */
export const confirmOwner = (data) => ({
    url: '/claim/confirm-owner/sms',
    method: 'POST',
    data,
});
